export function parseTranslationKey(fullKey: string): { namespace: string; key: string } {
  const colonIndex = fullKey.indexOf(':');
  if (colonIndex === -1) {
    return { namespace: 'backend', key: fullKey };
  }
  return {
    namespace: fullKey.substring(0, colonIndex),
    key: fullKey.substring(colonIndex + 1),
  };
}
